module.exports = __webpack_public_path__ + "img/info-grey.fd671730.svg";